import React from 'react';

export default function BarIcon(props) {
    return (
        <svg
            width="12"
            height="16"
            viewBox="0 0 12 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M11 14.6667V6.33337M6 14.6667V1.33337M1 14.6667V9.66671"
                stroke={props.color || "#FFFFFF"}
                strokeWidth="1.67"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
